module.exports = {"account":"Login to Your Account","login":"Login","o365":"Sign in with O365","google":"Sign in with Google","exchange":"Sign in with Exchange","local":"Sign in Local","remember":"Remember","email":"Email","password":"Password","error":"Required!","emailerror":"Invalid Email Address","OR":"OR"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/login/ENG.json
// module id = 1315
// module chunks = 121